<div>
  <p id="[{{_id}}]_Dokumente_Beschreibung1">
    Sollten Sie keinen Nachweis hochladen, kann dies gegebenenfalls zu Verzögerungen in der Bearbeitung führen.
  </p>
  <p id="[{{_id}}]_Dokumente_Beschreibung2">
    Es sind folgende Formate für das Hochladen zugelassen: PDF, JPG, JPEG, PNG (maximal 9 MB je Datei).
  </p>
  <p>
    Sie können die Nachweise auch mit Ihrem Smartphone abfotografieren und in den vorgenannten Formaten hochladen.
  </p>
</div>
